/**
 * Created by Denis Kuzin on 08 august 2024
 */

const MarkComponentView = cc.Node.extend({
    ctor: function (component, cellView) {
        this._super();

        this.setContentSize(cellView.getContentSize());
        this.setLocalZOrder(11);

        if (component.mark) {
            const markView = MarkView.factory(component.cell);
            markView.initialize(component.cell);
            this.addChild(markView);
        }
    }
});
